import { z } from 'zod'

import { conditionOperations } from './conditionOperation'

const questionFilterSchema = z.object({
  category: z.literal('Question'),
  question: z.object({
    questionId: z.string(),
    operation: z.enum(conditionOperations),
    answerOptions: z
      .array(z.object({ option: z.number(), text: z.string() }))
      .min(1),
  }),
})

const customerAttributeFilterSchema = z.object({
  category: z.literal('CustomerAttribute'),
  customerAttribute: z.object({
    customerAttributeIds: z.array(z.string()).min(1),
    operation: z.enum(conditionOperations),
  }),
})

const brandSegmentsFilterSchema = z.object({
  category: z.literal('BrandSegments'),
  brandSegments: z.object({
    brandGroupId: z.number(),
    brandNumber: z.number(),
    segmentNumbers: z.array(z.number()).min(1),
  }),
})

const surveyFilterSchema = z.discriminatedUnion('category', [
  questionFilterSchema,
  customerAttributeFilterSchema,
  brandSegmentsFilterSchema,
])

export type SurveyFilterItem = z.infer<typeof surveyFilterSchema>

const surveyFilterGroupSchema = z.array(surveyFilterSchema).min(1)

export const surveyFilterGroupsSchema = z.array(surveyFilterGroupSchema)

export type SurveyFilterGroups = z.infer<typeof surveyFilterGroupsSchema>
